import { removeAttachmentFromHistory } from "../../api/historyService";

export const useRemoveAttachmentFromHistory = (successCallback) => {
    const removeAttachment = async (id, attachmentId) => {
        try {
            await removeAttachmentFromHistory(id, attachmentId);
            successCallback();
        } catch (error) {
            console.error("Failed to remove attachment from history:", error);
            throw error;
        }
    };

    return { removeAttachment };
};